import React from 'react';

import { Select, SelectOption } from '@flixbus/honeycomb-react';

import { TIME_ZONES_ADDITIONS, TIME_ZONES_STANDARD } from 'utils/datetime';

const TZ_ARRAY_STANDARD = Object.values(TIME_ZONES_STANDARD);

const TimezoneTLSelect = ({ selected, additionalOptions = [], onSelection = () => {} }) => {
	const topList = [TIME_ZONES_ADDITIONS.myTime, ...additionalOptions];

	const handleChange = (e) => {
		const selectedValue = e.target.value;

		const allTimezones = [...topList, ...TZ_ARRAY_STANDARD];
		const timezone = allTimezones.find((tz) => {
			const tzValue = tz.value === null ? 'null' : String(tz.value);
			return tzValue === String(selectedValue);
		});

		if (timezone) {
			onSelection(timezone);
		}
	};

	const getCurrentValue = () => {
		if (!selected || selected.value === null || selected.value === undefined) {
			return 'null';
		}
		return String(selected.value);
	};

	return (
		<Select
			id="timezone-tl-select"
			label="Timezone"
			value={getCurrentValue()}
			onChange={handleChange}
		>
			{topList.map((elem) => (
				<SelectOption
					key={`${elem.value || 'null'}-${elem.name}`}
					value={elem.value === null ? 'null' : elem.value}
				>
					{elem.name}
				</SelectOption>
			))}
			{TZ_ARRAY_STANDARD.map((elem) => (
				<SelectOption key={elem.value} value={elem.value}>
					{elem.name}
				</SelectOption>
			))}
		</Select>
	);
};

export default TimezoneTLSelect;
